import { render } from "./AirQualityReport.vue?vue&type=template&id=b0f5aa10"
import script from "./AirQualityReport.vue?vue&type=script&lang=js"
export * from "./AirQualityReport.vue?vue&type=script&lang=js"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__